<template>
  <div>
    <v-app>
        <template >
          <v-card>
            <!-- <v-card-title>
      Driver List
    </v-card-title> -->
            <v-card-title>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="addData"
                v-if="role.create"
              >
                Add Driver
              </v-btn>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('all');
                        }
                      "
                    >
                      All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('filter');
                        }
                      "
                    >
                      All filtered record
                    </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex flex-wrap">
                <!-- filter date -->
                <!-- <div class="shadow d-flex">
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <p class="mt-5 fs-small">s/d</p>
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <v-btn :disabled="!search" class="mt-5" small color="primary">
                    <v-icon>mdi-calendar-filter</v-icon>
                  </v-btn>
                </div> -->
                <v-select
                  style=" max-width: 150px;"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search = ''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                  class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn
                  :disabled="!search"
                  class="mt-5"
                  small
                  color="primary"
                  @click="searchButton"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  v-if="searchValue"
                  class="mt-5 ml-1"
                  dark
                  small
                  color="red"
                  @click="clearSearchButton"
                  >Clear</v-btn
                >
              </div>
              <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
            </v-card-title>
            <!-- <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
      :options="{'itemsPerPage':50}" 
    > -->
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
            >
              <!-- <template v-slot:[`header.driver_business_unit`]="{ header }">
      <v-select
        style=" font-size:10px;"
        :items="optionBusinessUnit"
        :label="header.text"
        v-model="valueBusinessUnit"
        @change="getList"
        item-text="business_unit_name"
        item-value="id"
        class="ma-2"
        hide-details
      >
      </v-select>
    </template> -->

              <!-- <template v-slot:[`item.detail`]="{ item }">
      <md-button class="md-icon-button md-info md-dense" v-on:click="detailDriver(item.id)"></md-button>
          <router-link :to="{name: 'Detail Driver Black Plate', params: { id: item.id }}" class="btn btn-primary">Detail
          </router-link>
    </template> -->
              <!-- <template v-slot:[`item.driver_business_unit`]="{ item }">
         {{item.driver_business_unit.business_unit_name}}
    </template> -->

              <template v-slot:[`header.driver_status`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionDriverStatus"
                  :label="header.text"
                  v-model="valueDriverStatus"
                  @change="getList"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template>

              <template v-slot:[`item.driver_blacklist`]="{ item }">
                <span v-if="item.driver_blacklist == 0">Yes</span>
                <span v-if="item.driver_blacklist == 1">No</span>
              </template>

              <!-- <template  v-slot:[`item.driver_sim_no`]="{ item }">
        <template v-if="type_license['0']">
          <span>{{ item.driver_license.driver_license_no }}</span>
          </template>
    </template> -->

              <template v-slot:[`item.driver_status`]="{ item }">
                <span v-if="item.driver_status == 0">Registered</span>
                <span v-if="item.driver_status == 1">Waiting Approval</span>
                <span v-if="item.driver_status == 2">Rejected</span>
                <span v-if="item.driver_status == 3">Waiting DP</span>
                <span v-if="item.driver_status == 4">Waiting PKO</span>
                <span v-if="item.driver_status == 5">Active</span>
                <span v-if="item.driver_status == 6">Payment Completed</span>
                <span v-if="item.driver_status == 7">Terminate By Payment</span>
                <span v-if="item.driver_status == 8">Active Ownership</span>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="detailDriver(item.id)">
                      <v-list-item-title x-small>Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role.update"
                      @click="editData(item.id)"
                    >
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role.delete && item.driver_status == 0"
                      @click="deleteConfirmation(item.id)"
                    >
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </template>
    </v-app>
    <modal ref="modalDetailPage">
      <template v-slot:body>
        <list-vehicle-business-unit :data_id="$refs.modalDetailPage.data" />
      </template>
    </modal>
    <modal ref="modalAddPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto; ">
          <h3>ADD DRIVER</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAdd()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-driver />
      </template>
    </modal>

    <modal ref="modalEditData">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>EDIT DRIVER</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseEdit()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>

      <template v-slot:body>
        <edit-driver-data :data_id="$refs.modalEditData.data" />
      </template>
    </modal>

    <!-- <modal ref="modalAddDriverData" >
    <template v-slot:body >
      <add-driver-data />
      </template>
  </modal> -->
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import DetailDriver from "@/pages/Dashboard/Fms/Driver/DetailDPage.vue";
import EditDriver from "@/pages/Dashboard/Fms/Driver/EditDPage.vue";
import AddDriver from "@/pages/Dashboard/Fms/Driver/AddDPage.vue";
// import addDriver from "@/pages/Dashboard/Fms/Driver/AddDBPPage.vue";
import { Modal } from "@/components";
// import { ResizablePage } from "@/components";

export default {
  components: {
    downloadExcel: JsonExcel,
    "list-vehicle-business-unit": DetailDriver,
    Modal,
    "edit-driver-data": EditDriver,
    "add-driver": AddDriver,
  },
  vuetify,
  data() {
    return {
      // optionBusinessUnit: null,
      // valueBusinessUnit:0,
      mounted: true,
      loadTable: false,
      page: 1,
      options: {},
      totalDataTable: 0,
      numberOfPages: 0,
      searchValue: null,
      searchCategory: null,
      option_filter: [
        { text: "Driver Name", value: "driver_name" },
        { text: "KIP No", value: "driver_no" },
        { text: "Nickname", value: "driver_nickname" },
        { text: "Phone", value: "driver_phone_no" },
      ],
      valueDriverStatus: "",
      optionDriverStatus: [
        { text: "All", value: "" },
        { text: "Active Ownership", value: "8" },
        { text: "Terminated by Payment", value: "7" },
        { text: "Payment Completed", value: "6" },
        { text: "Active", value: "5" },
        { text: "Waiting PKO", value: "4" },
        { text: "Waiting DP", value: "3" },
        { text: "Rejected", value: "2" },
        { text: "Waiting Approval", value: "1" },
        { text: "Registered", value: "0" },
      ],
      role: "",
      me: "",
      search: "",
      headers: [
        // {
        //   text: 'Detail',
        //   align: 'start center',
        //   value: 'detail',
        //   sortable: false
        // },
        // {
        //   text: 'Driver No',
        //   align: 'start',
        //   value: 'driver_no',
        // },
        // { text: 'Business Unit', value: 'driver_business_unit', sortable: false },
        {
          text: "Actions",
          value: "actions",
          align: "start center",
          sortable: false,
        },
        { text: "Status", value: "driver_status", sortable: false, width:'200' },
        { text: "KIP No", value: "driver_no" },
        { text: "Driver Name", value: "driver_name", width:'200' },
        { text: "Nickname", value: "driver_nickname" , width:'200'},
        { text: "Driver Phone", value: "driver_phone_no" },
        // { text: 'SIM No', value: 'driver_sim_no' },
        { text: "Blacklisted", value: "driver_blacklist" },
        { text: "Created At", value: "created_at" , width:'200'},
      ],
      table: [],
      worksheetName: "Driver Black Plate",
      fileName: "Driver Black Plate.xls",
      exportDisplayedPage: [],
      exportAllFitered: [],
      field_export: {
        "No": "no",
        "Pool": "driver_pool",
        "KIP No": "driver_no",
        "Blacklist": "driver_blacklist",
        "Status": "driver_status",
        "Driver Name": "driver_name",
        "Nickname": "driver_nickname",
        "Address": "driver_address",
        // driver_business_unit : 'driver_business_unit',
        "Place of Birth": "driver_place_of_birth",
        "Date of Birth": "driver_date_of_birth",
        "DP": "driver_dp",
        // driver_type : 'driver_type',
        "Gender": "driver_gender",
        "Blood Type": "driver_blood_type",
        "Religion": "driver_religion",
        "Last Education": "driver_last_education",
        "Phone No": "driver_phone_no",
        "Emergency Phone No": "driver_emergency_phone_no",
        "No Identity": "no_identity",
        "Identity Type": "driver_identity_type",
        "Identity No": "driver_identity_no",
        "Identity Expire Date": "driver_identity_expire_date",
        "Identity Address": "driver_identity_address",
        "Place of Issue": "driver_identity_place_of_issue",
        "No License": "no_license",
        "License Type": "driver_license_type",
        "License No": "driver_license_no",
        "License Expire Date": "driver_license_expire_date",
        "License Address": "driver_license_address",
        "No Bank": "no_bank_account",
        "Bank Name": "driver_bank_account_bank_name",
        "Bank Account No": "driver_bank_account_no",
        "Bank Account Holder": "driver_bank_account_holder",
        "Created At": "created_at",
        "Updated At": "updated_at",
      },
    };
  },

  watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
       //set refs in root saat page terbuka, agar fungsi di page ini bisa di panggil dari page lain
    this.$root.$refs.ListDriverPage = this;
    //check saat page terbuka apakah ada params 
    if(this.$route.params.id){
      //open detail
      this.detailDriver(this.$route.params.id)
    }
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];
    this.me = await this.$store.getters["profile/me"]
    // this.onMounted()
    this.getList();
    this.mounted = false;
  },
  methods: {

    check_object_value(array, key, value) {
        //return array.some(object => object[key] === value);
        return array.some(object => value.includes(object[key]));
        },
        
    detailDriver(id) {
      this.$refs.modalDetailPage.openModal({ id: id });
    },

    addData() {
      this.$refs.modalAddPage.openModal();
    },

    modalCloseAdd() {
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    editData(id) {
      this.$refs.modalEditData.openModal({ id: id });
    },

    modalCloseEdit() {
      this.$refs.modalEditData.closeModal();
      this.getList();
    },

    modalCloseDetail() {
      this.$refs.modalDetailPage.closeModal();
      this.getList();
    },

    // addData(){
    //   this.$refs.modalAddDriverData.openModal()
    // },

    //  async onMounted(){
    //     await this.$store.dispatch("fms_business_unit/list");
    //    this.optionBusinessUnit = await this.$store.getters["fms_business_unit/list"];
    //     this.optionBusinessUnit.unshift({business_unit_name:"All",id:0});

    //  },
    // ambil data yang dibutuhkan
    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;
      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

      // if(this.valueBusinessUnit!=0){
      //   if(query.filter){
      //     Object.assign(query.filter, {driver_business_unit:this.valueBusinessUnit});
      //   }
      //   else{
      //     query.filter = {driver_business_unit:this.valueBusinessUnit}
      //   }
      // }

      if (this.valueDriverStatus != "") {
        if (query.filter) {
          Object.assign(query.filter, {
            driver_status: this.valueDriverStatus,
          });
        } else {
          query.filter = { driver_status: this.valueDriverStatus };
        }
      }

      await this.$store.dispatch("fms_driver/list", query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
      this.table = await this.$store.getters["fms_driver/list"];
      var pageMeta = await this.$store.getters["fms_driver/page"];
      // }
      // else{
      //   this.table = []
      // }
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },

    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
      // if(this.$refs.vTable){
      //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
      // }
      // else{
      //   this.exportAllFitered = this.dataExport(this.table)
      // }
    },

    // fungsi tombol direct ke add page
    // addData() {
    //   // panggil add page
    // this.$router.push({name: 'Add Driver Black Plate'});
    // },

    // fungsi tombol direct ke edit page
    // editData(id) {
    //   // panggil edit page
    //   this.$router.push({ name: 'Edit Driver Black Plate', params: { id: id } })
    // },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },

    // fungsi delete
    async deleteData(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("fms_driver/destroy", id);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Driver data delete successfully."
        );
        //await this.getList();
        var indexOptionTable = this.table.findIndex((p) => p.id == id);
        this.table.splice(indexOptionTable, 1);
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    // dataExport(data){
    //  return data.map((v,index) => ({...v, no: index+1}))

    // }

    async dataExportBefore(type) {
      if (this.table.length != 0) {
        console.log("ewww");
        if (type == "all") {
          await this.$store.dispatch("fms_driver/list");
          return this.dataExport(
            await this.$store.getters["fms_driver/list"]
          );
        } else if (type == "filter") {
          var query = {};

          // if(sortBy.length!=0){
          //   var  sort=sortBy[0]
          //   if(sortDesc[0]){
          //     sort="-"+sortBy[0]
          //   }
          //   query.sort = sort
          // }

          if (this.searchValue && this.searchCategory) {
            query.filter = { [this.searchCategory]: this.searchValue };
          }

          if (this.valueDriverStatus != "") {
            if (query.filter) {
              Object.assign(query.filter, {
                driver_status: this.valueDriverStatus,
              });
            } else {
              query.filter = { driver_status: this.valueDriverStatus };
            }
          }

          // if(this.valueBusinessUnit!=0){
          //   if(query.filter){
          //     Object.assign(query.filter, {driver_business_unit:this.valueBusinessUnit});
          //   }
          //   else{
          //     query.filter = {driver_business_unit:this.valueBusinessUnit}
          //   }
          // }

          await this.$store.dispatch("fms_driver/list", query);
          return this.dataExport(
            await this.$store.getters["fms_driver/list"]
          );
        }
      }
    },
    dataExport(data) {
      console.log(data);
      var dataReturn = [];
      data.forEach((value_1, index_1) => {
        var driver_place_of_birth = null;
        var driver_dp = null;
        var driver_type = null;
        // var driver_business_unit = null
        var driver_gender = null;
        var driver_blood_type = null;
        var driver_religion = null;
        var driver_blacklist = null;
        var driver_pool = null;

        var driver_last_education = null;

        // if(value_1.driver_business_unit){
        //   driver_business_unit = value_1.driver_business_unit.business_unit_name
        //   }

        if (value_1.driver_place_of_birth) {
          driver_place_of_birth = value_1.driver_place_of_birth.city_name;
        }

        if (value_1.driver_pool) {
          driver_pool = value_1.driver_pool.pool_name;
        }

        if (value_1.driver_dp) {
          driver_dp = value_1.driver_dp.dp_type.dp_amount;
        }

        if (value_1.driver_type == 0) {
          driver_type = "Bravo";
        } else if (value_1.driver_type == 1) {
          driver_type = "Charlie";
        }

        if (value_1.driver_blacklist == 0) {
          driver_blacklist = "Yes";
        } else if (value_1.driver_blacklist == 1) {
          driver_blacklist = "No";
        }

        // if (value_1.driver_pool == 0) {
        //   driver_pool = "Pool Kranggan Bekasi";
        // } else if (value_1.driver_pool == 1) {
        //   driver_pool = "Etc";
        // }

        if (value_1.driver_last_education == 0) {
          driver_last_education = "SD";
        } else if (value_1.driver_last_education == 1) {
          driver_last_education = "SMP";
        } else if (value_1.driver_last_education == 2) {
          driver_last_education = "SMA/SMK";
        } else if (value_1.driver_last_education == 3) {
          driver_last_education = "Universitas";
        } else if (value_1.driver_last_education == 4) {
          driver_last_education = "Lainnya";
        }

        if (value_1.driver_gender == 0) {
          driver_gender = "Pria";
        } else if (value_1.driver_gender == 1) {
          driver_gender = "Perempuan";
        }

        if (value_1.driver_blood_type == 0) {
          driver_blood_type = "A";
        } else if (value_1.driver_blood_type == 1) {
          driver_blood_type = "B";
        } else if (value_1.driver_blood_type == 2) {
          driver_blood_type = "AB";
        } else if (value_1.driver_blood_type == 3) {
          driver_blood_type = "O";
        }

        if (value_1.driver_religion == 1) {
          driver_religion = "Islam";
        } else if (value_1.driver_religion == 2) {
          driver_religion = "Kristen";
        } else if (value_1.driver_religion == 3) {
          driver_religion = "Katolik";
        } else if (value_1.driver_religion == 4) {
          driver_religion = "Budha";
        } else if (value_1.driver_religion == 5) {
          driver_religion = "Hindu";
        } else if (value_1.driver_religion == 6) {
          driver_religion = "Konghucu";
        } else if (value_1.driver_religion == 7) {
          driver_religion = "Lainya";
        }

        var driver_license_length = value_1.driver_license
          ? value_1.driver_license.length
          : 0;
        var driver_identity_length = value_1.driver_identity
          ? value_1.driver_identity.length
          : 0;
        var driver_bank_account_length = value_1.driver_bank_account
          ? value_1.driver_bank_account.length
          : 0;

        for (
          let i = 0;
          i <
          Math.max(
            driver_identity_length,
            driver_license_length,
            driver_bank_account_length
          );
          i++
        ) {
          var data = {
            no:
              dataReturn[index_1] && dataReturn[index_1].no == index_1 + 1
                ? null
                : index_1 + 1,
            driver_no: value_1.driver_no,
            driver_name: value_1.driver_name,
            driver_nickname: value_1.driver_nickname,
            driver_phone_no: "'"+value_1.driver_phone_no,
            driver_emergency_phone_no: value_1.driver_emergency_phone_no,
            driver_email: value_1.driver_email,
            driver_address: value_1.driver_address,
            // driver_business_unit: driver_business_unit,
            driver_place_of_birth: driver_place_of_birth,
            driver_date_of_birth: value_1.driver_date_of_birth,
            driver_type: driver_type,
            driver_pool: driver_pool,
            driver_dp: driver_dp,
            driver_last_education: driver_last_education,
            driver_gender: driver_gender,
            driver_blood_type: driver_blood_type,
            driver_religion: driver_religion,
            driver_blacklist: driver_blacklist,
            driver_status: value_1.driver_status
              ? this.export_type("status", value_1.driver_status)
              : "Registered",

            no_identity: value_1.driver_identity[i] ? i + 1 : null,
            driver_identity_type: value_1.driver_identity[i]
              ? this.export_type(
                  "identity",
                  value_1.driver_identity[i].driver_identity_type
                )
              : null,
            driver_identity_no: value_1.driver_identity[i]
              ? value_1.driver_identity[i].driver_identity_no
              : null,
            driver_identity_expire_date: value_1.driver_identity[i]
              ? value_1.driver_identity[i].driver_identity_expire_date
              : null,
            driver_identity_address: value_1.driver_identity[i]
              ? value_1.driver_identity[i].driver_identity_address
              : null,
            driver_identity_place_of_issue: value_1.driver_identity[i]
              ? value_1.driver_identity[i].driver_identity_place_of_issue
              : null,

            no_license: value_1.driver_license[i] ? i + 1 : null,
            driver_license_type: value_1.driver_license[i]
              ? this.export_type(
                  "identity",
                  value_1.driver_license[i].driver_license_type
                )
              : null,
            driver_license_no: value_1.driver_license[i]
              ? value_1.driver_license[i].driver_license_no
              : null,
            driver_license_expire_date: value_1.driver_license[i]
              ? value_1.driver_license[i].driver_license_expire_date
              : null,
            driver_license_address: value_1.driver_license[i]
              ? value_1.driver_license[i].driver_license_address
              : null,

            no_bank_account: value_1.driver_bank_account[i] ? i + 1 : null,
            driver_bank_account_bank_name: value_1.driver_bank_account[i]
              ? value_1.driver_bank_account[i].driver_bank_account_bank_name
              : null,
            driver_bank_account_no: value_1.driver_bank_account[i]
              ? value_1.driver_bank_account[i].driver_bank_account_no
              : null,
            driver_bank_account_holder: value_1.driver_bank_account[i]
              ? value_1.driver_bank_account[i].driver_bank_account_holder
              : null,

            created_at: value_1.created_at,
            updated_at: value_1.created_at,
          };

          dataReturn.push(data);
        }
      });
      console.log(dataReturn);
      return dataReturn;
    },
    export_type(type, item) {
      var return_data = null;
      if (type == "identity") {
        if (item == 0) {
          return_data = "KTP";
        } else if (item == 1) {
          return_data = "SKCK";
        } else if (item == 2) {
          return_data = "Domisili";
        } else if (item == 3) {
          return_data = "KK";
        }
      } else if (type == "license") {
        if (item == 0) {
          return_data = "A";
        }
        if (item == 1) {
          return_data = "A1 Umum";
        }
        if (item == 2) {
          return_data = "B";
        }
        if (item == 3) {
          return_data = "B2";
        }
        if (item == 4) {
          return_data = "B2 Umum";
        }
        if (item == 5) {
          return_data = "C";
        }
        if (item == 6) {
          return_data = "B1";
        }
        if (item == 7) {
          return_data = "B1 Umum";
        }
      } else if (type == "status") {
        if (item == null || item == 0) {
          return_data = "Registered";
        }
        if (item == 1) {
          return_data = "Waiting Approval";
        }
        if (item == 2) {
          return_data = "Rejected";
        }
        if (item == 3) {
          return_data = "Waiting DP";
        }
        if (item == 4) {
          return_data = "Waiting PKO";
        }
        if (item == 5) {
          return_data = "Active";
        }
        if (item == 6) {
          return_data = "Payment Completed";
        }
        if (item == 7) {
          return_data = "Terminate By Payment";
        }
        if (item == 8) {
          return_data = "Active Ownership";
        }
      }
      return return_data;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}

.btn-transparent {
  background-color: transparent !important;
}
</style>
